<template>
    <Layout>
        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <h3>Accommodation</h3>
                    <p class="lead">
                        Guests are kindly requested to book their own rooms at a
                        special EFG Hermes conference rate at the Atlantis, the
                        Palm Hotel. A reservation link will appear in your
                        browser after you submit your registration for the
                        conference.
                    </p>
                </div>
            </div>
        </section>

        <section
            id="register"
            class="section gradient-overlay bg-cover bg-hotel light-text align-center"
        >
            <div class="container">
                <h2 style="margin-bottom: 0;">Atlantis, The Palm</h2>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Deluxe Guest Rooms</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                Deluxe Rooms are designed with subtle oceanic
                                and Arabian influences, offering magnificent
                                partial views of the tranquil Arabian Sea or the
                                iconic Palm Island. You can give a preference
                                for either a king size or two queen size beds
                                subject to availability at check-in. Room sizes
                                are between 45 and 47 square meters.
                            </p>
                            <p>
                                Every Deluxe Room features a balcony and a
                                spacious bathroom which includes a walk-in
                                shower with separate bath and complimentary
                                bathroom amenities. Enjoy a range of in-room
                                features such as cable/satellite TV and 24-hour
                                room service as well as a number of benefits
                                including unlimited complimentary access to
                                Aquaventure Waterpark and The Lost Chambers
                                Aquarium and preferential rates to swim with
                                dolphins at Dolphin Bay.
                            </p>
                            <p>
                                Maximum occupancy: 2 adults and 2 children under
                                12 years of age or 3 adults and 1 child under 12
                                years of age.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Partial or full view of the Arabian Sea</li>
							<li><b>Size</b>: 45-47 square metres</li>
							<li><b>Occupancy</b>: 2 adults & 2 children or 3 adults & 1 child (children must be under 12yrs of age)</li>
							<li><b>Bedding</b>: King Size Bed (surcharges for extra bed)</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section gray-clr-bg">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Ocean Deluxe Guest Rooms</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                With the tranquility of the Arabian Sea right on
                                your doorstep, the Ocean Deluxe Rooms offer
                                unparalleled views of a spectacular sunset every
                                evening. You can indicate a preference for
                                either a king size or two queen size beds
                                subject to availability at check-in. Room sizes
                                are between 45 and 47 square meters.
                            </p>
                            <p>
                                Ocean Deluxe Rooms feature a balcony and a
                                spacious bathroom, which includes a walk-in
                                shower, separate bath, and complimentary
                                bathroom amenities. Enjoy a range of in-room
                                features such as cable/satellite TV and 24-hour
                                room service as well as a number of benefits
                                including unlimited complimentary access to
                                Aquaventure Waterpark and The Lost Chambers
                                Aquarium and preferential rates to swim with
                                dolphins at Dolphin Bay.
                            </p>
                            <p>
                                Maximum occupancy: 2 adults and 2 children under
                                12 years of age or 3 adults and 1 child under 12
                                years of age.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Partial or full view of Palm Island and Dubai Skyline</li>
							<li><b>Size</b>: 45-47 square metres</li>
							<li><b>Occupancy</b>: 2 adults & 2 children or 3 adults & 1 child (children must be under 12yrs of age)</li>
							<li><b>Bedding</b>: King size bed (surcharge for extra bed)</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Palm Beach Deluxe Guest Rooms</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                With stunning views across 1.4 km beach of
                                pristine beach, The Palm and the Dubai skyline,
                                The Palm Beach Deluxe Rooms are the most
                                popular, offering an unforgettable sight by day
                                and night. You can indicate a preference for
                                either a king size or two queen size beds
                                subject to availability at check-in.
                            </p>
                            <p>
                                Palm Beach Deluxe Rooms are 45-47 sqm and
                                feature a balcony and a luxurious and spacious
                                bathroom, which includes a walk-in shower with a
                                deep soaking tub and complimentary bathroom
                                amenities, perfect for relaxing after a long
                                day. Enjoy a range of in-room features such as
                                cable/satellite TV and 24-hour room service as
                                well as a number of benefits including unlimited
                                complimentary access to Aquaventure Waterpark
                                and The Lost Chambers Aquarium and preferential
                                rates to swim with dolphins at Dolphin Bay.
                            </p>
                            <p>
                                Maximum occupancy: 2 adults and 2 children under
                                12 years of age or 3 adults and 1 child under 12
                                years of age.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Arabian Sea and The Palm</li>
							<li><b>Size</b>: 94 square metres</li>
							<li><b>Occupancy</b>: 2 adults + 2 children below 12 years of age + 1 infant cot or 3 adults</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section gray-clr-bg">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Terrace Club Suites</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                With one of two bedroom options, the Terrace
                                Club Suites enjoy large balconies complete with
                                sun lounges and dining tables and stand at 94
                                square meters. If you enjoy unique scenic
                                panoramas, choose one of the Terrace Club
                                Suites, where you can sunbathe or dine in
                                complete privacy on your spacious and furnished
                                terrace balcony.
                            </p>
                            <p>
                                Club Suites are in the centre of each tower and
                                offer views of the Arabian Sea or The Palm and
                                Dubai Skyline. Each Terrace Club Suite has a
                                bedroom, an impeccably furnished lounge, a small
                                dining table, desk and terrace.
                            </p>
                            <p>
                                The Bathrooms are well proportioned with large
                                oval, free-standing baths situated in the middle
                                of the room and walk-in showers. You also have
                                the flexibility of creating a two-bedroom suite,
                                as all the Terrace Club Suites interconnect with
                                a double queen room, bookable as a separate unit
                                and subject to availability.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Exquisite views of the Arabian Sea and The Palm</li>
							<li><b>Size</b>: 101 square metres</li>
							<li><b>Occupancy</b>: 2 adults + 2 children below 12 years of age + 1 infant cot or 3 adults</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Exclusive Offers</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                Atlantis, The Palm has a number of exclusive
                                offers available for participants of the One on
                                One 2020 Conference.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Stunning views across The Palm and the Dubai skyline or the Arabian Sea</li>
							<li><b>Size</b>: 164 square metres</li>
							<li><b>Occupancy</b>: 2 adults + 2 children below 12 years of age + 1 infant cot or 3 adults</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section gray-clr-bg">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Dining</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                Enjoy an exclusive 15% discount (meals only) at
                                Atlantis, The Palm’s dining venues including
                                Ossiano, Nobu, and Wavehouse.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Exquisite views of the Arabian Sea and The Palm</li>
							<li><b>Size</b>: 101 square metres</li>
							<li><b>Occupancy</b>: 2 adults + 2 children below 12 years of age + 1 infant cot or 3 adults</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Transportation</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                Enjoy 10% off all transfers to and from Dubai
                                International Airport.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Stunning views across The Palm and the Dubai skyline or the Arabian Sea</li>
							<li><b>Size</b>: 164 square metres</li>
							<li><b>Occupancy</b>: 2 adults + 2 children below 12 years of age + 1 infant cot or 3 adults</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section gray-clr-bg">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Attractions</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                Get a 15% discount on all dolphin and sealion
                                interactions.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Stunning views across The Palm and the Dubai skyline or the Arabian Sea</li>
							<li><b>Size</b>: 164 square metres</li>
							<li><b>Occupancy</b>: 2 adults + 2 children below 12 years of age + 1 infant cot or 3 adults</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-4">
                            <h3>Spa Treatments</h3>
                        </div>

                        <div class="col-md-8">
                            <p>
                                Treat yourself to any spa treatment or hair
                                service and get a 15% discount.
                            </p>
                            <p>
                                *Discount applies to all spa treatments and hair
                                services except Zerobody, LPG, Bastien Gonzales,
                                and Dr. Burgener treatments.
                            </p>
                            <!-- <h6>ROOM DETAILS</h6>
						<ul>
							<li><b>View</b>: Stunning views across The Palm and the Dubai skyline or the Arabian Sea</li>
							<li><b>Size</b>: 164 square metres</li>
							<li><b>Occupancy</b>: 2 adults + 2 children below 12 years of age + 1 infant cot or 3 adults</li>
							<li>Includes Unlimited Access To Waterpark And Aquarium</li>
						</ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="contacts">
            <div class="contacts-wrapper">
                <div
                    id="contacts-map"
                    class="map"
                    data-settings="hotel-map-settings.json"
                    style="height:560px;"
                ></div>

                <div class="container contacts-on-map-container">
                    <div class="contacts-on-map">
                        <h3>Atlantis, the Palm Hotel</h3>
                        <p>
                            Crescent Road, The Palm Island<br />
                            P.O.Box 211222, Dubai, UAE
                        </p>
                        <ul class="list">
                            <li><i class="fa fa-phone"></i>+971 4 426 2000</li>
                            <li>
                                <i class="fa fa-envelope"></i
                                ><a href="mailto:info@atlantisthepalm.com"
                                    >info@atlantisthepalm.com</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <section class="section gray-clr-bg">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="bottom-links">
                            <div class="col-md-6">
                                <a
                                    href="#"
                                    class="btn btn-sm btn-secondary btn-block"
                                    >Participation Guidelines (Presenters)</a
                                >
                            </div>
                            <div class="col-md-6">
                                <a
                                    href="#"
                                    class="btn btn-sm btn-secondary btn-block"
                                    >Brochure (Investors)</a
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
    name: "Accommodation",
    components: { Layout }
};
</script>
